import apiClient from '@/api/index'
import router from '@/router';

export const reportEditPlanModule = {
    namespaced: true,

    state:() => ({
        reportData: {},
        reportLoading: true,
        excelData: {},
        totalData: {}
    }),

    mutations: {
        setReportData(state, data) {
            state.reportData = data
        },

        setExcelData(state, data) {
            state.excelData = data
        },
        setTotalData(state, data) {
            state.totalData = data
        }
    },

    actions: {
        async getReportData({ commit, state }) {
            state.reportLoading = true
            try {
                const response = await apiClient.get("/sale-plans/" + router.currentRoute.value.query['shop'] + '?month=' + router.currentRoute.value.query['month'], {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                commit('setReportData', response.data.results)
                commit('setExcelData', response.data.results)
                commit('setTotalData', response.data.totals)
            } catch(err) { // Если есть ошибка
                alert(err)
            }

            state.reportLoading = false
        },

        async changeData({}, data) {
            const summary = {}
            summary[data.type] = data.value
            console.log(summary);
            // switch(data.type) {
            //     case 'revenue':
            //         summary = {
            //             revenue: data.value 
            //         }
            //         break;
            //     case 'orders':
            //         summary = {
            //             orders: data.value 
            //         }
            //         break;    
            //     case 'orders':
            //         summary = {
            //             orders: data.value 
            //         }
            //         break;
            //     case 'efficient':
            //         summary = {
            //             efficient: data.value 
            //         }
            //         break;
            //     case 'order_time':
            //         summary = {
            //             order_time: data.value 
            //         }
            //     break;
            //     case 'nps':
            //         summary = {
            //             nps: data.value 
            //         }
            //         break;
            //     case 'percentage_kiosks':
            //         summary = {
            //             percentage_kiosks: data.value 
            //         }
            //     break;
            //     case 'smartmetrics':
            //         summary = {
            //             smartmetrics: data.value 
            //         }
            //         break;
            //     case 'average_check':
            //         summary = {
            //             average_check: data.value 
            //         }
            //         break;
            //     case 'yandex_percentage':
            //         summary = {
            //             yandex_percentage: data.value 
            //         }
            //         break;
            //     case 'yandex_percentage':
            //         summary = {
            //             yandex_percentage: data.value 
            //         }
            //         break;
            // }

            try {
                const response = await apiClient.patch("/sale-plans/" + router.currentRoute.value.query['shop'] + '/' + data.id + '/',
                summary,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },
    }
}